import { Component, OnInit } from '@angular/core';
import { isMPay, isSkycash } from '../../../../core/utils/utils';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {ResourceService} from '../../../services/resource.service';
import {TranslationDefinition} from '../../../models/translation-definition';
import {ResourceKey} from '../../../../core/consts/resource-key.enum';

@Component({
  selector: 'app-personal-data-administrator-section',
  templateUrl: './personal-data-administrator-section.component.html',
  styleUrls: ['./personal-data-administrator-section.component.scss']
})
export class PersonalDataAdministratorSectionComponent implements OnInit {

  attachmentsTranslation: TranslationDefinition;

  get sectionVisible(): boolean {
    return (isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin;
  }

  constructor(private urlParamsService: UrlParamsService,
              private resourceService: ResourceService) { }

  ngOnInit() {
    this.initAttachmentsTranslation();
  }

  private initAttachmentsTranslation() {
    this.attachmentsTranslation = {
      path: 'PERSONAL_DATA_ADMINISTRATOR_SECTION.attachments',
      params: {
        iddUri: this.resourceService.buildResourceUrlFromKey(ResourceKey.KP_IDD),
        personalDataAdministratorInfoUri: this.resourceService.buildResourceUrlFromKey(ResourceKey.KP_PERSONAL_DATA_ADMINISTRATOR_INFO),
      }
    }
  }

}
